import React from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Header from './DataComponent__TableHeader';
import Loading from '../Loading';

const DataComponentTablePromo = ({
    data: propData,
    loading: propLoading,
    t
}) => {
    const staticNames = t?.dataTable || {};

    const getKey = (data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }

        return data;
    };

    return (
        <div className="loading-wrapper">
            {propLoading && propData.length
                ? <div className="loading-wrapper__item"><Loading/></div>
                : null
            }
            {propData.map((item, i) => {
                let className = item.className;
                delete item.className;

                return (
                    <div className="promo-wrap" key={i}>
                        <div className="wrap__desktop">
                            <div className="promo-header">
                                <span className="promo-header__num">#{item.id} </span>
                                <span>{item.selfLink}</span>
                            </div>
                            <div className="promo-image">{item.image}</div>
                            <div className="promo-title"><span>{item.title}</span></div>
                            <div className="promo-link"><span>{item.url}</span></div>
                            <div className="promo-actions">
                                {item.action}
                            </div>
                        </div>
                        <div className="wrap__mobile">
                            <div className="promo-content">
                                <div className="promo-image">{item.image}</div>
                                <div className="promo-info-container">
                                    <div className="promo-header">
                                        <span className="promo-header__num">#{item.id} </span>
                                        <span>{item.selfLink}</span>
                                    </div>
                                    <div className="promo-title"><span>{item.title}</span></div>
                                    <div className="promo-link"><span>{item.url}</span></div>
                                </div>
                            </div>
                            <div className="promo-actions">
                                {item.action}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

DataComponentTablePromo.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    t: PropTypes.object
};

DataComponentTablePromo.defaultProps = {
    data: [],
    loading: false
};

export default withTranslation(DataComponentTablePromo);